import { EditDialog, Password, Text } from '@104ha/base-ui';
import { Col } from '../../components/col';
import { FormGroup, Label } from '../../components/form';
import { accountMaxText, dialogHeight, dialogWidth, formError } from './const';

const inputs = {
	userAccount: null,
	userName: null,
	pwd: null,
	newPwd: null,
	rePwd: null,
};

type Keys = keyof typeof inputs;

class EditPasswordDialog extends EditDialog<{ id?: number }> {
	static defaultProps = {
		...EditDialog.defaultProps,
		title: '編輯API使用者連接帳號',
		width: dialogWidth,
		height: dialogHeight,
		api: '/api/manage/privilege/password/update',
		errCode: formError,
		successMsg: '編輯帳號完成',
		okText: '確定修改',
	};

	inputs: {
		[key in Keys]?: {
			getValue: () => any;
			setState: (params: any) => any;
		} | null;
	} = inputs;

	setValues(inputs: { [key in Keys]?: any }) {
		super.setValues(inputs);
	}

	renderBody() {
		return (
			<>
				<FormGroup>
					<Label>API登入帳號</Label>
					<Col span={16}>
						<Text
							{...{
								ref: (ele: any) => (this.inputs.userAccount = ele),
								validate: {
									required: true,
									max: accountMaxText,
								},
								readOnly: true,
							}}
						/>
					</Col>
				</FormGroup>
				<FormGroup>
					<Label>帳號名稱</Label>
					<Col span={16}>
						<Text
							{...{
								ref: (ele: any) => (this.inputs.userName = ele),
								validate: {
									required: true,
									max: accountMaxText,
								},
								readOnly: true,
							}}
						/>
					</Col>
				</FormGroup>
				<FormGroup>
					<Label required>原密碼</Label>
					<Col span={16}>
						<Password
							{...{
								ref: (ele: any) => (this.inputs.pwd = ele),
								validate: {
									required: true,
									max: accountMaxText,
								},
								autoComplete: 'new-password',
							}}
						/>
					</Col>
				</FormGroup>
				<FormGroup>
					<Label required>密碼</Label>
					<Col span={16}>
						<Password
							{...{
								ref: (ele: any) => (this.inputs.newPwd = ele),
								validate: {
									required: true,
									max: accountMaxText,
								},
								autoComplete: 'new-password',
							}}
						/>
					</Col>
				</FormGroup>
				<FormGroup>
					<Label required>再次輸入密碼</Label>
					<Col span={16}>
						<Password
							{...{
								ref: (ele: any) => (this.inputs.rePwd = ele),
								validate: {
									required: true,
									max: accountMaxText,
								},
							}}
						/>
					</Col>
				</FormGroup>
			</>
		);
	}
}
export { EditPasswordDialog };
